var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PolicyDocument',{attrs:{"id":_vm.id,"notice-url":_vm.noticeUrl,"data-external":"policy-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }